import { Swiper, Navigation, Pagination, EffectFade } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, EffectFade]);

export default () => {
    var swiper = new Swiper('.gallery-modal-slider', {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
    });

    var swiper = new Swiper('.home-main-slider__slider', {
        pagination: {
            el: '.swiper-pagination'
        }
    });

    var swiper = new Swiper('.highlights-section__text-slider', {
        pagination: {
            el: '.highlight-pagination'
        },
        navigation: {
            nextEl: '.highlight-slide-next',
            prevEl: '.highlight-slide-prev',
        },
    });

    var swiper = new Swiper('.highlights-section__model-slider', {
        pagination: {
            el: '.swiper-pagination'
        },
        navigation: {
            nextEl: '.highlight-slide-next',
            prevEl: '.highlight-slide-prev',
        },
    });

    var swiper = new Swiper('.category-section__slider', {
        navigation: {
            nextEl: '.category-section__slide-next',
            prevEl: '.category-section__slide-prev',
        },
        slidesPerView: 3,
        initialSlide: 1,
        centeredSlides: true,
        loop: true,
        breakpoints: {
            1199: {
                slidesPerView: 1
            }
        }
    });

    var swiper = new Swiper('.category-section__subcategory-slider', {
        navigation: {
            nextEl: '.category-section__slide-next',
            prevEl: '.category-section__slide-prev',
        },
        loop: true,
        initialSlide: 1,
    });

    var swiper = new Swiper('.single-product-slider', {
        watchOverflow: true,
        navigation: {
          nextEl: '.single-product-next',
          prevEl: '.single-product-prev',
        },
    });

    var slideVideo = new Swiper('.slide-video', {
        slidesPerView: 1,
        watchOverflow: true,
        speed: 1000,
        fadeEffect: {
            crossFade: true,
        },
        effect: 'fade',
        navigation: {
          nextEl: '.video__next',
          prevEl: '.video__prev',
        },
    });
};


